import * as z from "zod/v4";

/**
 * Unified page context structure for agents.
 * Used to pass page-specific information from the frontend to agents.
 */
export const PageContextSchema = z.object({
  /**
   * Human-readable description of the current page context.
   * Example: "User is viewing return for order number: #1098, return ID: abc123"
   */
  pageDescription: z.string().optional(),

  /**
   * Preferred agent to route to when triage is involved.
   * Examples: "analytics", "returns-specific", "oms", "marketing", "shopper-ai"
   */
  preferredAgent: z.string().optional(),

  /**
   * Page-specific data as key-value pairs.
   * Structure varies by page type:
   * - Returns page: { returnId: string, orderId: string }
   * - Analytics page: { reportTitle: string, analysisStartDate: string, analysisEndDate: string, reportContent: string }
   */
  pageData: z.record(z.string(), z.unknown()).optional(),
});

export type PageContext = z.infer<typeof PageContextSchema>;
